export const FEATURED_FEED = 'FEATURED_FEED'
export const POST_FEED = 'POST_FEED'